// import React from 'react'

// type CustomLegendProps = {
//     items: {
//         name: string
//         color: string
//     }[]
//     series: {
//         name: string
//         color: string
//         valueField: string
//     }[]
//     onHover?: (name: string) => void
//     onLeave?: () => void
//     onClick?: (name: string) => void
// }

// export default function CustomLegend({
//     items,
//     series,
//     onHover,
//     onLeave,
//     onClick,
// }: CustomLegendProps) {
//     return (
//         <div className="grid grid-cols-5 gap-4 mt-4">
//             {series.map((serie) => (
//                 <div
//                     key={serie.name}
//                     className="flex flex-col items-center cursor-pointer hover:opacity-80 transition-all duration-200"
//                     onMouseEnter={() => onHover?.(serie.name)}
//                     onMouseLeave={() => onLeave?.()}
//                     onClick={() => onClick?.(serie.name)}
//                 >
//                     <div className="text-xs text-center">{serie.name}</div>
//                     <div
//                         className="w-3 h-3 mt-1 rounded-sm"
//                         style={{ backgroundColor: serie.color }}
//                     ></div>
//                 </div>
//             ))}
//         </div>
//     )
// }


import React from 'react'

type CustomLegendProps = {
    series: {
        name: string
        color: string
        valueField: string
    }[]
    onHover?: (name: string) => void
    onLeave?: () => void
    onClick?: (name: string) => void
}

export default function CustomLegend({
    series,
    onHover,
    onLeave,
    onClick,
}: CustomLegendProps) {
    return (
        <div className="flex flex-col gap-2 mt-4">
            {series.map((serie) => (
                <div
                    key={serie.name}
                    className="flex items-start gap-2 cursor-pointer hover:text-primary-600 transition-all duration-200 min-h-[1.5rem]"
                    onMouseEnter={() => onHover?.(serie.name)}
                    onMouseLeave={() => onLeave?.()}
                    onClick={() => onClick?.(serie.name)}
                >
                    {/* สีสี่เหลี่ยมเล็ก - ขนาดคงที่เสมอ */}
                    <div
                        className="w-3 h-3 rounded-sm flex-shrink-0 mt-0.5"
                        style={{ backgroundColor: serie.color }}
                    ></div>

                    {/* ชื่อ legend */}
                    <div className="text-xs max-w-[6rem] leading-snug break-words flex items-center">
                        <span className="text-left">{serie.name}</span>
                    </div>
                </div>
            ))}
        </div>
    )
}
